import React, { useState,useEffect } from 'react';
import { Link, useNavigate } from 'react-router';
import {
    FaEye,
    FaEdit,
    FaTrash,
    FaUserTie,
    FaCheckCircle,
    FaTimesCircle,
    FaUserTimes,
    FaUsers
} from 'react-icons/fa';
import { useDispatch } from "react-redux";
import { successToast, errorToast } from '../../Utils/toast';
import { openModal } from "../../redux/features/modalSlice";
import {
    useGetRejectedSadasyaQuery,
    useUpdateSadasyaStatusMutation,
} from '../../redux/services/sadsayamember/sadsya.Services';
import CommonBreadcrumb from '../../common/CommonBreadcrumb';
function RejectedMembers() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [search, setSearch] = useState('');
    const [selectedUsers, setSelectedUsers] = useState([]);
    // ✅ 1. localStorage से role और waad_id लें
    const [userRole, setUserRole] = useState('');
    const [userWaadId, setUserWaadId] = useState('');

    useEffect(() => {
        try {
            const role = localStorage.getItem('userRole');
            const waadId = localStorage.getItem('userWaadId');

            if (role) setUserRole(role);
            if (waadId) setUserWaadId(waadId);

            console.log("🔍 User Role from localStorage:", role);
            console.log("🔍 User Waad ID from localStorage:", waadId);
        } catch (error) {
            console.error("Error reading localStorage:", error);
        }
    }, []);

    const {
        data: rejectedData,
        isLoading,
        isError,
        error,
        refetch
    } = useGetRejectedSadasyaQuery(
        {
            waad_id: userWaadId,
            role: userRole
        }
    );

    const [updateUserStatus, { isLoading: isUpdating }] = useUpdateSadasyaStatusMutation();

    const handleUpdateStatus = async (userId, status) => {
        try {
            await updateUserStatus({ id: userId, status }).unwrap();
            successToast(`User status updated successfully`);
            refetch();
        } catch (error) {
            errorToast(error?.data?.message || 'Failed to update status');
        }
    };

    const toggleUserSelection = (userId) => {
        setSelectedUsers(prev =>
            prev.includes(userId)
                ? prev.filter(id => id !== userId)
                : [...prev, userId]
        );
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedUsers(rejectedData?.data?.map(u => u.id) || []);
        } else {
            setSelectedUsers([]);
        }
    };

    const handleBulkApprove = async () => {
        if (selectedUsers.length === 0) {
            errorToast('Please select at least one user');
            return;
        }

        try {
            for (const userId of selectedUsers) {
                await updateUserStatus({ id: userId, status: 1 }).unwrap();
            }
            successToast(`${selectedUsers.length} users approved successfully`);
            setSelectedUsers([]);
            refetch();
        } catch (error) {
            errorToast(error?.data?.message || 'Bulk approval failed');
        }
    };

    const handleBulkPending = async () => {
        if (selectedUsers.length === 0) {
            errorToast('Please select at least one user');
            return;
        }

        try {
            for (const userId of selectedUsers) {
                await updateUserStatus({ id: userId, status: 2 }).unwrap();
            }
            successToast(`${selectedUsers.length} users moved to pending`);
            setSelectedUsers([]);
            refetch();
        } catch (error) {
            errorToast(error?.data?.message || 'Bulk update failed');
        }
    };

    const handleViewUser = (userId) => {
        navigate(`/pariwar-view/${userId}`);
    };

    const handleEditUser = (user) => {
        dispatch(
            openModal({
                type: "edit-pariwar-member",
                title: "Edit Member",
                data: user
            })
        );
    };

    const handleDeleteUser = (user) => {
        dispatch(
            openModal({
                type: "delete-pariwar-member",
                title: "Delete Member",
                data: user
            })
        );
    };

    // Filter data based on search
    const filteredData = rejectedData?.data?.filter(user => {
        if (!search) return true;
        const searchLower = search.toLowerCase();
        return (
            user.name?.toLowerCase().includes(searchLower) ||
            user.mobile?.toLowerCase().includes(searchLower) ||
            user.email?.toLowerCase().includes(searchLower) ||
            user.sadasya_unique_id?.toLowerCase().includes(searchLower)
        );
    }) || [];

    // Loading state
    if (isLoading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-danger" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    // Error state
    if (isError) {
        return (
            <div className="alert alert-danger m-3">
                Error: {error?.data?.message || 'Something went wrong'}
            </div>
        );
    }

    return (
        <div>

            {/* =============================================
                PAGE HEADER
                ============================================= */}
            {/* <div className="page-header-breadcrumb all_breadcrumb">
                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
                    <nav>
                        <h4 className="fw-semibold">
                            <FaUserTimes className="me-2 text-danger" />
                            Rejected Members
                        </h4>
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/pariwar-members">Members</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Rejected
                            </li>
                        </ol>
                    </nav>
                </div>
                <div className="page-title fw-semibold fs-18 mb-0">
                    <button
                        className="btn btn-danger"
                        onClick={() => refetch()}
                    >
                        <FaUsers className="me-2" />
                        Refresh
                    </button>
                </div>
            </div> */}
<CommonBreadcrumb
    title="Rejected Members"
    titleIcon={<FaUserTimes className="me-2 text-danger" />}
    breadcrumbs={[
        { label: "Home", link: "/" },
        { label: "Members", link: "/pariwar-members" },
        { label: "Rejected" },
    ]}
    buttons={[
        {
            text: "Refresh",
            icon: <FaUsers className="me-2" />,
            onClick: refetch,
            className: "btn btn-primary",
        },
    ]}
/>
            {/* =============================================
                STATUS SUMMARY
                ============================================= */}
            <div className="card bg-danger bg-opacity-10 border-danger mb-4">
                <div className="card-body d-flex justify-content-between align-items-center">
                    <div>
                        <h5 className="mb-1">Total Rejected Members</h5>
                        <h2 className="mb-0">{rejectedData?.count || 0}</h2>
                    </div>
                    <div className="bg-danger bg-opacity-25 p-4 rounded-circle">
                        <FaUserTimes className="text-danger fs-1" />
                    </div>
                </div>
            </div>

            {/* =============================================
                SEARCH & BULK ACTIONS
                ============================================= */}
            <div className="card shadow-sm mb-4">
                <div className="card-body">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search by name, mobile, email, ID..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </div>
                        <div className="col-md-6 text-end">
                            <button
                                className="btn btn-success me-2"
                                onClick={handleBulkApprove}
                                disabled={selectedUsers.length === 0 || isUpdating}
                            >
                                <FaCheckCircle className="me-2" />
                                Approve Selected ({selectedUsers.length})
                            </button>
                            <button
                                className="btn btn-warning"
                                onClick={handleBulkPending}
                                disabled={selectedUsers.length === 0 || isUpdating}
                            >
                                <FaTimesCircle className="me-2" />
                                Move to Pending ({selectedUsers.length})
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* =============================================
                TABLE
                ============================================= */}
            <div className="st-wrapper-card">
                <div className="st-table-responsive">
                    <table className="table st-custom-table align-middle mb-0">
                        <thead>
                            <tr>
                                <th style={{ width: '40px' }}>
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        onChange={handleSelectAll}
                                        checked={selectedUsers.length === filteredData.length && filteredData.length > 0}
                                    />
                                </th>
                                <th>#ID</th>
                                <th>Name</th>
                                <th>Mobile</th>
                                <th>Email</th>
                                <th>Gotra</th>
                                <th className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.length === 0 ? (
                                <tr>
                                    <td colSpan="7" className="text-center py-4">
                                        <div className="text-muted">
                                            <FaUserTimes className="fs-2 d-block mx-auto mb-2" />
                                            No rejected members found
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                filteredData.map((user) => (
                                    <tr key={user.id}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={selectedUsers.includes(user.id)}
                                                onChange={() => toggleUserSelection(user.id)}
                                            />
                                        </td>
                                        <td>#{user.id}</td>
                                        <td className="fw-semibold">{user.name}</td>
                                        <td>{user.mobile || '-'}</td>
                                        <td>{user.email || '-'}</td>
                                        <td>{user.self_gotra || '-'}</td>
                                        <td>
                                            <div className="d-flex justify-content-center gap-2">
                                                {/* Status Dropdown */}
                                                <select
                                                    className="form-select form-select-sm"
                                                    style={{ width: '120px' }}
                                                    onChange={(e) => handleUpdateStatus(user.id, parseInt(e.target.value))}
                                                    value={user.status}
                                                    disabled={isUpdating}
                                                >
                                                    <option value="2">⏳ Pending</option>
                                                    <option value="1">✅ Success</option>
                                                    <option value="3">❌ Reject</option>
                                                </select>

                                                {/* View Button */}
                                                <button
                                                    className="st-action-btn st-view-btn"
                                                    onClick={() => handleViewUser(user.id)}
                                                    title="View Details"
                                                >
                                                    <FaEye />
                                                </button>

                                                {/* Edit Button */}
                                                <button
                                                    className="st-action-btn st-edit-btn"
                                                    onClick={() => handleEditUser(user)}
                                                    title="Edit Member"
                                                >
                                                    <FaEdit />
                                                </button>

                                                {/* Delete Button */}
                                                <button
                                                    className="st-action-btn st-delete-btn"
                                                    onClick={() => handleDeleteUser(user)}
                                                    title="Delete Member"
                                                >
                                                    <FaTrash />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    );
}

export default RejectedMembers;